export const ROAD_HEADER_SIZE = 29;
export const MAX_ROAD_RESULTS = 1024;

export function bytesOf(value) {
  if (value instanceof Uint8Array) return value;
  if (value instanceof ArrayBuffer) return new Uint8Array(value);
  if (ArrayBuffer.isView(value)) return new Uint8Array(value.buffer, value.byteOffset, value.byteLength);
  throw new Error('Binary road requires bytes');
}

export function decodeRoad(value) {
  const bytes = bytesOf(value);
  if (bytes.length < ROAD_HEADER_SIZE || bytes[0] !== 1) throw new Error('Invalid road header');
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
  const record = {
    table: view.getUint16(1),
    revision: view.getUint32(3),
    bootId: view.getBigUint64(7).toString(),
    setId: view.getBigUint64(15).toString(),
    total: view.getUint16(23),
    start: view.getUint16(25),
    codes: bytes.slice(29)
  };
  if (!record.revision || record.total > MAX_ROAD_RESULTS || view.getUint16(27) !== record.codes.length || record.start + record.codes.length !== record.total || record.codes.some(code => code > 12)) {
    throw new Error('Invalid road length/revision/code');
  }
  return record;
}

export function encodeRoad(record) {
  const codes = bytesOf(record.codes);
  const bytes = new Uint8Array(ROAD_HEADER_SIZE + codes.length);
  const view = new DataView(bytes.buffer);
  bytes[0] = 1;
  view.setUint16(1, record.table);
  view.setUint32(3, record.revision);
  view.setBigUint64(7, BigInt(record.bootId));
  view.setBigUint64(15, BigInt(record.setId));
  view.setUint16(23, record.total);
  view.setUint16(25, record.start);
  view.setUint16(27, codes.length);
  bytes.set(codes, 29);
  decodeRoad(bytes);
  return bytes;
}

// A gap is explicit and repaired with an authenticated full snapshot. Never
// append out of sequence, guess the missing result, or replay settlement.
export function applyRoadRecord(previous, next) {
  if (previous && next.revision < previous.revision) return { status: 'stale', record: previous };
  if (next.start === 0) {
    if (previous && next.revision === previous.revision && next.bootId === previous.bootId && next.codes.length === previous.codes.length && next.codes.every((code, index) => code === previous.codes[index])) {
      return { status: 'duplicate', record: previous };
    }
    return { status: 'applied', record: next };
  }
  if (!previous || next.bootId !== previous.bootId || next.revision !== previous.revision + 1 || next.start !== previous.codes.length) {
    if (previous && next.revision === previous.revision) return { status: 'duplicate', record: previous };
    return { status: 'gap', record: previous || null };
  }
  const codes = new Uint8Array(next.total);
  codes.set(previous.codes);
  codes.set(next.codes, next.start);
  return { status: 'applied', record: { ...next, start: 0, codes } };
}
